import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { GetReleasesRequest, GetReleasesResponse, ReadReleaseRequest, ReadReleaseResponse } from './dto';
import { ReleasesAPIRoutes } from './routes';

// TODO: to change it to the direct call to Studio API
export function getReleases(params: GetReleasesRequest): Promise<GetReleasesResponse> {
  return makeRequest(
    api.get(ReleasesAPIRoutes.getReleases(), {
      params: {
        ...params,
        workspaceTypeIDs: JSON.stringify(params.workspaceTypeIDs),
      },
    }),
  );
}

// TODO: to change it to the direct call to Studio API
export function readRelease(body: ReadReleaseRequest): Promise<ReadReleaseResponse> {
  return makeRequest(api.post(ReleasesAPIRoutes.readRelease(), body));
}
